import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientProjectGrid: [],
    workClientProjectGrid_working: [],
    workClientProjectGrid_filter: [],
    workClientProjectAll: [],
    workClientProjectAllInWork: [],
    workClientProjectProgress: [],
    workClientProjectStatistic: {},
    workClientProjectOrdersReport: [],
    workClientProjectAmount: 0,
    workClientProjectShow: {},
    pageData: null,
    workClientProjectExtraWorkGrid: [],
    workClientProjectPeriods: [],
    workClientProjectAllReports: [],
  },
  getters: {
    workClientProjectGrid: (state) => {
      return state.workClientProjectGrid
    },
    workClientProjectGrid_working: (state) => {
      return state.workClientProjectGrid_working
    },
    workClientProjectAmount: (state) => {
      return state.workClientProjectAmount
    },
    workClientProjectAll: (state) => {
      return state.workClientProjectAll
    },
    workClientProjectAllInWork: (state) => {
      return state.workClientProjectAllInWork
    },
    workClientProjectGrid_filter: (state) => {
      return state.workClientProjectGrid_filter
    },
    workClientProjectProgress: (state) => {
      return state.workClientProjectProgress
    },
    workClientProjectStatistic: (state) => {
      return state.workClientProjectStatistic
    },
    workClientProjectShow: (state) => {
      return state.workClientProjectShow
    },
    pageData: (state) => {
      return state.pageData
    },
    workClientProjectOrdersReport: (state) => {
      return state.workClientProjectOrdersReport
    },
    workClientProjectExtraWorkGrid: (state) => {
      return state.workClientProjectExtraWorkGrid
    },
    workClientProjectPeriods: (state) => {
      return state.workClientProjectPeriods
    },
    workClientProjectAllReports: (state) => {
      return state.workClientProjectAllReports
    },
  },
  mutations: {
    setWorkClientProjectGrid(state, payload) {
      state.workClientProjectGrid = payload
    },
    setWorkClientProjectAmount(state, payload) {
      state.workClientProjectAmount = payload
    },
    setWorkClientProjectAll(state, payload) {
      state.workClientProjectAll = payload
    },
    setWorkClientProjectAllInWork(state, payload) {
      state.workClientProjectAllInWork = payload
    },
    setWorkClientProjectGrid_working(state, payload) {
      state.workClientProjectGrid_working = payload
    },
    setWorkClientProjectGrid_filter(state, payload) {
      state.workClientProjectGrid_filter = payload
    },
    setWorkClientProjectShow(state, payload) {
      state.workClientProjectShow = payload ? payload : {}
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setWorkClientProjectProgress(state, payload) {
      state.workClientProjectProgress = payload
    },
    setWorkClientProjectStatistic(state, payload) {
      state.workClientProjectStatistic = payload ? payload : {}
    },
    setWorkClientProjectOrdersReport(state, payload) {
      state.workClientProjectOrdersReport = payload
    },
    setWorkClientProjectExtraWorkGrid(state, payload) {
      state.workClientProjectExtraWorkGrid = payload
    },
    setWorkClientProjectPeriods(state, payload) {
      state.workClientProjectPeriods = payload
    },
    setWorkClientProjectAllReports(state, payload) {
      state.workClientProjectAllReports = payload
    },
  },
  actions: {
    onWorkClientProjectGrid({ commit, rootState }, { limit, page, sort, search }) {
      let url =
        rootState.apiDomain + '/api/admin/work/client/project/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectExtraWorkGrid({ commit, rootState }, { employee_id, start_date, end_date }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/extra?employee_id=' +
            employee_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectExtraWorkGrid', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectGrid_filter({ commit, rootState }, { limit, page, filter, order, search }) {
      commit('setWorkClientProjectGrid_filter', {})
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/project/grid?limit=' +
        limit +
        '&page=' +
        page
      if (order) {
        for (let i in order)
          if (order[i])
            url = url + '&order[]=' + i + ':' +  order[i]
      } else url = url + '&order[]=name:asc'
      for (let i in filter)
        url = url + '&filter[]=' + i + ':' +  filter[i]
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectGrid_filter', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectGrid_working({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&order[]=name:asc' +
            '&filter[]=status:working',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectGrid_working', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectAmount({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/grid?limit=1&page=1' +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectAmount', resp.data.amount)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/grid?limit=0' +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectAllInWork({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
              rootState.apiDomain +
              '/api/admin/work/client/project/grid?limit=0' +
              '&order[]=name:asc&filter[]=status:pending,in_progress',
          method: 'GET',
        })
            .then((resp) => {
              commit('setWorkClientProjectAllInWork', resp.data.data)
              resolve(resp)
            })
            .catch((err) => {
              reject(err)
            })
      })
    },
    onWorkClientProjectProgress({ commit, rootState }, {filter, search}) {

      let url = rootState.apiDomain +
              '/api/admin/work/client/project/progress?'
      if (filter) {
        for (let i in filter) {
          if (filter[i])
            url = url + 'filter[]=' + i + ':' + filter[i] + '&'
        }
      }
      if (search) url = url + 'search=' + search + '&'

      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectProgress', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectOrdersReport({ commit, rootState }, { filtersStatus }) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/orders-report' +
            '?limit=0&page=1' +
            '&order[]=name:asc' +
            (filtersStatus ? '&filter[]=status:' + filtersStatus : ''),
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectOrdersReport', resp.data.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectStatistic({ commit, rootState }, idProject) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/statistic/' + idProject,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectStatistic', resp.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        if (data.images_in_report === undefined || data.images_in_report === null) {
          data.images_in_report = false
        }
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectUpdate_status({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/status',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectPeriods({ commit, rootState }, { statusFilter }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/periods' +
            '?limit=0&page=1' +
            '&order[]=id:desc' +
            '&filter[]=status:' +
            statusFilter,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectPeriods', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectPeriodReports({ commit, rootState }, { projectId, start, end }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/period-report' +
            '?project_id=' +
            projectId +
            '&start_date=' +
            start +
            '&end_date=' +
            end,
          method: 'GET',
        })
          .then((resp) => {
            // commit('setWorkClientProjectPeriods', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectAllReports({ commit, rootState }, { limit, page, filter, sort }) {
      commit('setWorkClientProjectAllReports', {})
      let url =
          rootState.apiDomain +
          '/api/admin/work/client/project/reports?limit=' +
          limit +
          '&page=' +
          page
      if (filter.period && filter.period.length > 0) url = url + '&start=' + filter.period[0] + '&end=' + filter.period[1]
      if(filter.status) url = url + '&status=' + filter.status
      if(filter.project) {
        let projects = filter.project
        for (let p in projects) {
          url = url + '&project_ids[]=' + projects[p]
        }
      }
      if(filter.client) {
        let clients = filter.client
        for (let c in clients) {
          url = url + '&client_ids[]=' + clients[c]
        }
      }
      if(filter.weeks) {
        let weeks_year = filter.weeks
        for (let w in weeks_year) {
          url = url + '&weeks[' + w + '][week_year]=' + weeks_year[w].year + '&weeks[' + w + '][week_number]=' + weeks_year[w].week
        }
      }
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=created_at:desc'
      }
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
            .then((resp) => {
              commit('setWorkClientProjectAllReports', resp.data)
              resolve(resp)
            })
            .catch((err) => {
              reject(err)
            })
      })
    },
}
}
